import type { ReactNode } from 'react';
import { Typography } from '../Typography';

export interface CounterProps {
  /** Progress or count displayed in the counter. */
  count: ReactNode;
  /** Optional test hook for consumers that need to identify the counter. */
  testId?: string;
}

/** A compact counter for progress and completion totals. */
export function Counter({ count, testId }: CounterProps) {
  return (
    <span
      data-testid={testId}
      className="inline-flex h-5 shrink-0 items-center justify-center rounded-xs bg-interactive-loud px-2"
    >
      <Typography variant="button" size="small" color="white" as="span">
        {count}
      </Typography>
    </span>
  );
}

export default Counter;
